import './_index.scss';
import React from "react";
import Element from '../../basic/element';
import axios from "axios";
import CodeExchangeCard from "../codeExchangeCard/CodeExchangeCard";
import EcosystemExchangeCard from "../EcosystemExchangeCard";
import AutomationExchangeCard from "../AutomationExchangeCard";
import SectionFrame from "../../basic/sectionFrame";

const PROD_API_HOST = "https://devnet.cisco.com";

export default class Index extends React.Component {
    static defaultProps = {
        envsensitive: false,
        apihost: PROD_API_HOST,
        apirelativeurl: '/v1/foundation-search/catalogs/query',
        apiquerystring: "",
        repourlquerystring: "",
        limit: 3,
        icon: null,
        title: null,
        description: null,
        actions: [],
        loading: null,
        noentry: null,
        target: "",
        hideIfNoResult: false,
        applyViewMore: false,
        viewAllText: "View All",
        viewMoreText: "View More",
        viewMoreSize: 15
    }

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            loadingMore: false,
            entries: null
        };

        this.loadMorePageNum = this.props.viewMoreSize ? (parseInt(this.props.limit / this.props.viewMoreSize) + 1) : 1;
    }

    componentDidMount() {
        const limit = this.props.limit;
        axios.get(this.buildApiUrl(limit, 1)).then((response) => {
            this.setState({ loading: false, entries: response.data })
        })
    }

    render() {
        const className = this.buildClassName();
        const { entries, columns } = this.renderEntries();
        let { icon, title, description } = this.props;
        let header = { icon, title, description };
        let { actions } = this.props;
        const viewAllAction = this.renderViewMore();
        let footer = { actions, beforeActions: viewAllAction };

        if (this.props.hideIfNoResult && this.isNoEntry()) {
            return (
                <div className='pubhub-exchange hidden'></div>
            );
        }

        return (
            <SectionFrame
                id={this.props.id}
                className={className}
                style={this.props.style}
                columns={columns}
                header={header}
                footer={footer}>
                {entries}
            </SectionFrame>
        );
    }

    renderEntries() {
        if (this.state.loading) {
            return { entries: this.renderLoading(), columns: 1 };
        }

        if (this.isNoEntry()) {
            return { entries: this.renderNoEntry(), columns: 1 };
        }

        let columns = 3;
        const repohost = this.props.apihost == PROD_API_HOST ? 'https://developer.cisco.com' : '';
        const target = this.props.target || '_self';
        const entries = this.state.entries.items.map((i, index) => {
            if (i.type == "Code") {
                return <CodeExchangeCard 
                    repohost={repohost}
                    repourlquerystring={this.props.repourlquerystring}
                    data={i} 
                    key={this.state.title + "code-exchange-card-" + index} 
                    target={target} />
            }

            if (i.type == "Ecosystem") {
                return <EcosystemExchangeCard 
                    repohost={repohost}
                    data={i} 
                    key={this.state.title + "ecosystem-exchange-card-" + index}
                    order={index} 
                    target={target} />
            }
        });

        return { entries, columns };

    }

    renderViewMore() {
        if (!this.props.applyViewMore) return null;

        if (this.isNoEntry()) return null;

        if (this.state.entries.items.length >= this.state.entries.total) return null;

        if (this.state.loadingMore) {
            return this.renderLoading();
        }

        const nextPageItemCount = this.loadMorePageNum == 1 ? this.props.viewMoreSize : (this.state.entries.items.length + this.props.viewMoreSize);
        const viewMoreText = nextPageItemCount >= this.state.entries.total ? this.props.viewAllText : this.props.viewMoreText;
        return (
            <div className='view-more-action action btn btn-primary btn-lg-wide' onClick={this.onLoadMore}>
                {viewMoreText}
            </div>
        );
    }

    renderLoading() {
        const loading = this.props.loading ? this.props.loading : { html: "<div class='pubhub-loading'></div>" };

        return this.renderUnusual('loading-indicator', loading);
    }

    renderNoEntry() {
        return this.renderUnusual('empty-indicator', this.props.noentry || 'No entry');
    }

    renderUnusual(className, data) {
        return (
            <div className='entries'>
                <div className='container'>
                    <Element className={className} data={data} />
                </div>
            </div>
        );
    }

    buildClassName() {
        return [
            'pubhub-exchange pubhub-widget',
            this.state.loading ? 'loading' : '',
            (!this.state.loading && this.isNoEntry()) ? 'no-entry' : ''
        ].filter((i) => i).join(' ');
    }

    isNoEntry() {
        return (!this.state.entries || !this.state.entries.items || this.state.entries.items.length == 0);
    }

    buildApiUrl(pageSize, pageNum) {
        const queryStr = this.props.apiquerystring + ('&pageSize=' + pageSize) + ('&pageNum=' + pageNum);
        const queryString = queryStr.replace("fastMode=true&", "").replace("keyPrefix", "key").replace("sortBy=name", "sortBy=name.keyword");
        const apiUrl = this.props.apihost + this.props.apirelativeurl;
        return apiUrl + '?' + queryString;
    }

    onLoadMore = () => {
        this.setState({ loadingMore: true })
        axios.get(this.buildApiUrl(this.props.viewMoreSize, this.loadMorePageNum)).then((response) => {
            const items = this.loadMorePageNum == 1 ? response.data.items : [...this.state.entries.items, ...response.data.items];
            this.loadMorePageNum++;
            this.setState({ loadingMore: false, entries: { ...response.data, items } })
        })
    }
}
